import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ConfirmBooking = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const [status, setStatus] = useState('loading');
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      setStatus('error');
      return;
    }

    const confirm = async () => {
      try {
        await axios.get(`${BACKEND_URL}/api/bookings/confirm/${id}`);
        setStatus('success');
      } catch (e) {
        console.error(e);
        setStatus('error');
      }
    };
    confirm();
  }, [id]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-4">
      <div className="max-w-md w-full bg-neutral-900 border border-white/10 p-8 rounded-2xl text-center">
        {status === 'loading' && (
          <p className="text-xl animate-pulse">Validation de la session en cours...</p>
        )}
        
        {status === 'success' && (
          <div className="space-y-4">
            <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto text-green-500">
              <CheckCircle className="w-10 h-10" />
            </div>
            <h1 className="text-2xl font-bold text-white">Session Confirmée !</h1>
            <p className="text-gray-400">Le client a été notifié par email.</p>
            <button onClick={() => navigate('/')} className="px-6 py-2 bg-white text-black rounded-full font-bold">
              Retour au site
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-4">
            <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto text-red-500">
              <XCircle className="w-10 h-10" />
            </div>
            <h1 className="text-2xl font-bold text-white">Erreur</h1>
            <p className="text-gray-400">Lien invalide ou session déjà traitée.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmBooking;
